/**
 * Enum for the AI sequence generator steps
 */
export enum AiSequenceGeneratorSteps {
  INITIATE_AI_SEQUENCE = 'INITIATE_AI_SEQUENCE',
  COMPANY_INFO = 'COMPANY_INFO',
  COMPANY_DATA_CONFIRM = 'COMPANY_DATA_CONFIRM',
  GOAL_SELECTION = 'GOAL_SELECTION',
  GOAL_REFINEMENT = 'GOAL_REFINEMENT',
  SERVICE_SELECTION = 'SERVICE_SELECTION',
  ICP_GENERATION = 'ICP_GENERATION',
  SEQUENCE_LENGTH = 'SEQUENCE_LENGTH',
  SEQUENCE_GENERATION = 'SEQUENCE_GENERATION',
}
